
import { SimplifiedPlannerProcess } from "@oculai/planner";
import { defineComponent, PropType } from "vue";
import SlideOver from "@/components/planner/SlideOver.vue";
import ProcessSideBarContent from "./ProcessSideBarContent.vue";

export default defineComponent({
  name: "ProcessSideBar",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    processes: {
      type: Array as PropType<Array<SimplifiedPlannerProcess & { name?: string }>>,
      required: true,
    },
    resourceFullName: {
      type: String,
      required: true,
    },
  },
  emits: ["closed"],
  components: {
    SlideOver,
    ProcessSideBarContent,
  },
});
